// extracted by mini-css-extract-plugin
module.exports = {"labels":"ProductLabels_labels__2raBx","label":"ProductLabels_label__1eSKK","popular":"ProductLabels_popular__2lXmd","sold_out":"ProductLabels_sold_out__26Gt1"};